import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from './MetaPixel';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
  fullWidth?: boolean;
}
const CHECKOUT_URL = 'https://pay.hotmart.com/H104664281M?off=z644l2f6';
export function CTAButton({
  children,
  onClick,
  href,
  className = '',
  fullWidth = true
}: CTAButtonProps) {
  const handleClick = () => {
    if (onClick) {
      // Custom onClick (e.g. scroll to offer) — do NOT track AddToCart
      onClick();
    } else {
      // This is a checkout redirect — track AddToCart
      trackAddToCart();
      const targetUrl = href || CHECKOUT_URL;
      window.open(targetUrl, '_blank', 'noopener,noreferrer');
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} animate={{
    boxShadow: ['0px 0px 0px 0px rgba(230, 126, 34, 0)', '0px 0px 20px 5px rgba(230, 126, 34, 0.4)', '0px 0px 0px 0px rgba(230, 126, 34, 0)']
  }} transition={{
    duration: 2,
    repeat: Infinity,
    repeatType: 'reverse'
  }} onClick={handleClick} className={`
        bg-gradient-to-b from-cta-amber to-cta-orange 
        text-white font-bold text-lg md:text-xl py-4 px-8 
        rounded-lg shadow-lg border-b-4 border-orange-700
        active:border-b-0 active:translate-y-1 transition-all
        ${fullWidth ? 'w-full' : ''} 
        ${className}
      `} data-id="element-73">
      {children}
    </motion.button>;
}